// extracted by mini-css-extract-plugin
export default {"ShareLinkModal":"yFtsOe9hx21NIZL1TxY1","ModalContent":"DOYUyE3HxRwnpYYlKxN3","ShareLinkModal__BtnGroup":"GKVx9sPVVDP7198C8DSR","ShareLinkModal__Button":"_691P5pzZM9iP8b2Yg6d7"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"ShareLinkModal\":\"yFtsOe9hx21NIZL1TxY1\",\"ModalContent\":\"DOYUyE3HxRwnpYYlKxN3\",\"ShareLinkModal__BtnGroup\":\"GKVx9sPVVDP7198C8DSR\",\"ShareLinkModal__Button\":\"_691P5pzZM9iP8b2Yg6d7\"}";
        // 1778765597760
        var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  